module.exports = __webpack_public_path__ + "img/vehicle-status-bus.a09c46c5.svg";